import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { ColorPalettePage } from './pages/ColorPalettePage';
type PaletteMode = 'light' | 'dark';
type PaletteVars = {
  '--gold-light': string;
  '--gold': string;
  '--gold-dark': string;
  '--gold-darker': string;
  '--mountain-light': string;
  '--mountain': string;
  '--mountain-dark': string;
  '--mountain-darker': string;
  '--sand-lightest': string;
  '--sand-light': string;
  '--sand': string;
  '--sand-dark': string;
};
type Palette = {
  id: string;
  name: string;
  colors: [string, string, string, string, string];
  light: PaletteVars;
  dark: PaletteVars;
};
const PALETTES: Palette[] = [{
  id: 'alpine',
  name: 'Classic Alpine Dawn',
  colors: ['#1A1A2E', '#E8C547', '#F4A261', '#E76F51', '#F8F4E3'],
  light: {
    '--gold-light': '232 198 143',
    '--gold': '212 165 116',
    '--gold-dark': '201 152 74',
    '--gold-darker': '184 134 11',
    '--mountain-light': '122 149 168',
    '--mountain': '95 122 138',
    '--mountain-dark': '74 107 124',
    '--mountain-darker': '61 90 108',
    '--sand-lightest': '250 247 240',
    '--sand-light': '245 241 232',
    '--sand': '232 220 200',
    '--sand-dark': '212 197 169'
  },
  dark: {
    '--gold-light': '232 198 143',
    '--gold': '212 165 116',
    '--gold-dark': '201 152 74',
    '--gold-darker': '184 134 11',
    '--mountain-light': '122 149 168',
    '--mountain': '95 122 138',
    '--mountain-dark': '74 107 124',
    '--mountain-darker': '61 90 108',
    '--sand-lightest': '14 14 22',
    '--sand-light': '22 22 34',
    '--sand': '32 32 48',
    '--sand-dark': '44 44 64'
  }
}, {
  id: 'nordic',
  name: 'Nordic Fjord',
  colors: ['#0F3460', '#16213E', '#E94560', '#F5A623', '#FDEBD0'],
  light: {
    '--gold-light': '245 166 35',
    '--gold': '233 69 96',
    '--gold-dark': '201 48 80',
    '--gold-darker': '160 24 64',
    '--mountain-light': '45 74 122',
    '--mountain': '30 58 106',
    '--mountain-dark': '22 33 62',
    '--mountain-darker': '15 52 96',
    '--sand-lightest': '253 235 208',
    '--sand-light': '245 213 168',
    '--sand': '232 192 128',
    '--sand-dark': '212 168 88'
  },
  dark: {
    '--gold-light': '245 166 35',
    '--gold': '233 69 96',
    '--gold-dark': '201 48 80',
    '--gold-darker': '160 24 64',
    '--mountain-light': '45 74 122',
    '--mountain': '30 58 106',
    '--mountain-dark': '22 33 62',
    '--mountain-darker': '15 52 96',
    '--sand-lightest': '8 14 28',
    '--sand-light': '12 20 40',
    '--sand': '18 30 56',
    '--sand-dark': '26 42 72'
  }
}, {
  id: 'violet',
  name: 'Ethereal Violet Dawn',
  colors: ['#2E1760', '#7B2D8B', '#FF9A3C', '#FFD700', '#FFF8F0'],
  light: {
    '--gold-light': '255 215 0',
    '--gold': '255 154 60',
    '--gold-dark': '224 128 32',
    '--gold-darker': '192 96 16',
    '--mountain-light': '90 58 154',
    '--mountain': '74 42 138',
    '--mountain-dark': '123 45 139',
    '--mountain-darker': '46 23 96',
    '--sand-lightest': '255 248 240',
    '--sand-light': '255 240 224',
    '--sand': '255 228 200',
    '--sand-dark': '255 212 168'
  },
  dark: {
    '--gold-light': '255 215 0',
    '--gold': '255 154 60',
    '--gold-dark': '224 128 32',
    '--gold-darker': '192 96 16',
    '--mountain-light': '90 58 154',
    '--mountain': '74 42 138',
    '--mountain-dark': '123 45 139',
    '--mountain-darker': '46 23 96',
    '--sand-lightest': '12 6 24',
    '--sand-light': '20 10 38',
    '--sand': '30 16 55',
    '--sand-dark': '44 24 72'
  }
}, {
  id: 'gold-midnight',
  name: 'Gold & Midnight',
  colors: ['#ECA72C', '#053C5E', '#9B5DE5', '#EE4266', '#FEFEFE'],
  light: {
    '--gold-light': '236 167 44',
    '--gold': '238 66 102',
    '--gold-dark': '200 48 80',
    '--gold-darker': '160 24 64',
    '--mountain-light': '155 93 229',
    '--mountain': '5 60 94',
    '--mountain-dark': '3 40 64',
    '--mountain-darker': '2 24 40',
    '--sand-lightest': '254 254 254',
    '--sand-light': '245 240 232',
    '--sand': '234 224 208',
    '--sand-dark': '216 200 176'
  },
  dark: {
    '--gold-light': '236 167 44',
    '--gold': '238 66 102',
    '--gold-dark': '200 48 80',
    '--gold-darker': '160 24 64',
    '--mountain-light': '155 93 229',
    '--mountain': '5 60 94',
    '--mountain-dark': '3 40 64',
    '--mountain-darker': '2 24 40',
    '--sand-lightest': '4 10 18',
    '--sand-light': '8 16 28',
    '--sand': '12 24 40',
    '--sand-dark': '18 34 54'
  }
}, {
  id: 'bright-carnival',
  name: 'Bright Carnival',
  colors: ['#FECC00', '#384199', '#E460A2', '#03A3CC', '#FFFFFF'],
  light: {
    '--gold-light': '254 204 0',
    '--gold': '228 96 162',
    '--gold-dark': '200 64 136',
    '--gold-darker': '168 32 112',
    '--mountain-light': '3 163 204',
    '--mountain': '56 65 153',
    '--mountain-dark': '36 46 128',
    '--mountain-darker': '20 30 96',
    '--sand-lightest': '254 254 254',
    '--sand-light': '245 242 255',
    '--sand': '232 228 255',
    '--sand-dark': '208 204 238'
  },
  dark: {
    '--gold-light': '254 204 0',
    '--gold': '228 96 162',
    '--gold-dark': '200 64 136',
    '--gold-darker': '168 32 112',
    '--mountain-light': '3 163 204',
    '--mountain': '56 65 153',
    '--mountain-dark': '36 46 128',
    '--mountain-darker': '20 30 96',
    '--sand-lightest': '10 8 20',
    '--sand-light': '16 14 32',
    '--sand': '24 20 48',
    '--sand-dark': '34 30 64'
  }
}, {
  id: 'warm-amber',
  name: 'Warm Amber Gradient',
  colors: ['#184A8C', '#F2B807', '#F2A20C', '#F28B0C', '#BF8665'],
  light: {
    '--gold-light': '242 184 7',
    '--gold': '242 162 12',
    '--gold-dark': '242 139 12',
    '--gold-darker': '212 112 10',
    '--mountain-light': '74 122 184',
    '--mountain': '46 96 152',
    '--mountain-dark': '30 74 124',
    '--mountain-darker': '24 74 140',
    '--sand-lightest': '255 248 232',
    '--sand-light': '255 240 208',
    '--sand': '245 216 160',
    '--sand-dark': '191 134 101'
  },
  dark: {
    '--gold-light': '242 184 7',
    '--gold': '242 162 12',
    '--gold-dark': '242 139 12',
    '--gold-darker': '212 112 10',
    '--mountain-light': '74 122 184',
    '--mountain': '46 96 152',
    '--mountain-dark': '30 74 124',
    '--mountain-darker': '24 74 140',
    '--sand-lightest': '12 10 6',
    '--sand-light': '20 16 8',
    '--sand': '30 24 10',
    '--sand-dark': '44 34 14'
  }
}, {
  id: 'rose-violet',
  name: 'Rose & Violet',
  colors: ['#292c73', '#fc3367', '#9379fe', '#fefefd', '#f0ecff'],
  light: {
    '--gold-light': '147 121 254',
    '--gold': '252 51 103',
    '--gold-dark': '208 24 80',
    '--gold-darker': '168 0 64',
    '--mountain-light': '90 74 170',
    '--mountain': '61 52 144',
    '--mountain-dark': '41 44 115',
    '--mountain-darker': '26 28 80',
    '--sand-lightest': '254 254 253',
    '--sand-light': '245 242 255',
    '--sand': '232 228 255',
    '--sand-dark': '208 204 240'
  },
  dark: {
    '--gold-light': '147 121 254',
    '--gold': '252 51 103',
    '--gold-dark': '208 24 80',
    '--gold-darker': '168 0 64',
    '--mountain-light': '90 74 170',
    '--mountain': '61 52 144',
    '--mountain-dark': '41 44 115',
    '--mountain-darker': '26 28 80',
    '--sand-lightest': '10 8 20',
    '--sand-light': '16 12 32',
    '--sand': '24 18 46',
    '--sand-dark': '34 26 62'
  }
}, {
  id: 'purple-teal',
  name: 'Purple Teal',
  colors: ['#533b84', '#00a6de', '#f65394', '#f9b030', '#fff5f8'],
  light: {
    '--gold-light': '249 176 48',
    '--gold': '246 83 148',
    '--gold-dark': '208 48 112',
    '--gold-darker': '176 16 80',
    '--mountain-light': '0 166 222',
    '--mountain': '0 128 176',
    '--mountain-dark': '83 59 132',
    '--mountain-darker': '54 32 96',
    '--sand-lightest': '255 245 248',
    '--sand-light': '255 232 244',
    '--sand': '255 208 232',
    '--sand-dark': '240 184 216'
  },
  dark: {
    '--gold-light': '249 176 48',
    '--gold': '246 83 148',
    '--gold-dark': '208 48 112',
    '--gold-darker': '176 16 80',
    '--mountain-light': '0 166 222',
    '--mountain': '0 128 176',
    '--mountain-dark': '83 59 132',
    '--mountain-darker': '54 32 96',
    '--sand-lightest': '14 8 18',
    '--sand-light': '22 12 28',
    '--sand': '32 18 40',
    '--sand-dark': '44 24 54'
  }
}, {
  id: 'navy-gold',
  name: 'Navy & Gold',
  colors: ['#002478', '#29509e', '#fbc617', '#fbfffa', '#f0f4ff'],
  light: {
    '--gold-light': '251 198 23',
    '--gold': '240 168 0',
    '--gold-dark': '208 136 0',
    '--gold-darker': '176 104 0',
    '--mountain-light': '74 112 190',
    '--mountain': '41 80 158',
    '--mountain-dark': '20 56 128',
    '--mountain-darker': '0 36 120',
    '--sand-lightest': '251 255 250',
    '--sand-light': '240 244 255',
    '--sand': '220 232 255',
    '--sand-dark': '192 208 240'
  },
  dark: {
    '--gold-light': '251 198 23',
    '--gold': '240 168 0',
    '--gold-dark': '208 136 0',
    '--gold-darker': '176 104 0',
    '--mountain-light': '74 112 190',
    '--mountain': '41 80 158',
    '--mountain-dark': '20 56 128',
    '--mountain-darker': '0 36 120',
    '--sand-lightest': '6 8 18',
    '--sand-light': '10 14 28',
    '--sand': '16 20 42',
    '--sand-dark': '24 30 58'
  }
}, {
  id: 'silver-crimson',
  name: 'Silver & Crimson',
  colors: ['#323f69', '#bf294c', '#e2ab05', '#dcdfdf', '#f5f5f5'],
  light: {
    '--gold-light': '226 171 5',
    '--gold': '191 41 76',
    '--gold-dark': '154 24 56',
    '--gold-darker': '120 8 32',
    '--mountain-light': '90 106 144',
    '--mountain': '62 80 128',
    '--mountain-dark': '50 63 105',
    '--mountain-darker': '32 40 64',
    '--sand-lightest': '245 245 245',
    '--sand-light': '232 232 234',
    '--sand': '220 223 223',
    '--sand-dark': '200 204 204'
  },
  dark: {
    '--gold-light': '226 171 5',
    '--gold': '191 41 76',
    '--gold-dark': '154 24 56',
    '--gold-darker': '120 8 32',
    '--mountain-light': '90 106 144',
    '--mountain': '62 80 128',
    '--mountain-dark': '50 63 105',
    '--mountain-darker': '32 40 64',
    '--sand-lightest': '12 12 16',
    '--sand-light': '20 20 26',
    '--sand': '30 30 38',
    '--sand-dark': '42 42 52'
  }
}, {
  id: 'electric-violet',
  name: 'Electric Violet',
  colors: ['#560BAD', '#7209B7', '#F72585', '#FDC500', '#FFD500'],
  light: {
    '--gold-light': '253 197 0',
    '--gold': '247 37 133',
    '--gold-dark': '210 20 110',
    '--gold-darker': '170 8 88',
    '--mountain-light': '114 9 183',
    '--mountain': '86 11 173',
    '--mountain-dark': '60 8 130',
    '--mountain-darker': '40 5 90',
    '--sand-lightest': '255 252 248',
    '--sand-light': '255 245 235',
    '--sand': '255 232 200',
    '--sand-dark': '255 213 0'
  },
  dark: {
    '--gold-light': '253 197 0',
    '--gold': '247 37 133',
    '--gold-dark': '210 20 110',
    '--gold-darker': '170 8 88',
    '--mountain-light': '114 9 183',
    '--mountain': '86 11 173',
    '--mountain-dark': '60 8 130',
    '--mountain-darker': '40 5 90',
    '--sand-lightest': '14 6 22',
    '--sand-light': '22 8 34',
    '--sand': '32 12 48',
    '--sand-dark': '44 16 64'
  }
}, {
  id: 'cosmic-pop',
  name: 'Cosmic Pop',
  colors: ['#3A0CA3', '#724CF9', '#F94E9B', '#FFD21F', '#FFDB4C'],
  light: {
    '--gold-light': '255 219 76',
    '--gold': '249 78 155',
    '--gold-dark': '210 48 124',
    '--gold-darker': '168 20 96',
    '--mountain-light': '114 76 249',
    '--mountain': '58 12 163',
    '--mountain-dark': '40 8 130',
    '--mountain-darker': '24 4 96',
    '--sand-lightest': '255 252 240',
    '--sand-light': '255 246 220',
    '--sand': '255 234 180',
    '--sand-dark': '255 210 31'
  },
  dark: {
    '--gold-light': '255 219 76',
    '--gold': '249 78 155',
    '--gold-dark': '210 48 124',
    '--gold-darker': '168 20 96',
    '--mountain-light': '114 76 249',
    '--mountain': '58 12 163',
    '--mountain-dark': '40 8 130',
    '--mountain-darker': '24 4 96',
    '--sand-lightest': '12 6 22',
    '--sand-light': '20 8 36',
    '--sand': '30 12 52',
    '--sand-dark': '42 16 70'
  }
}, {
  id: 'violet-spectrum',
  name: 'Violet Spectrum',
  colors: ['#7209b7', '#3a0ca3', '#f72585', '#fdc500', '#fafbfa'],
  light: {
    '--gold-light': '253 197 0',
    '--gold': '247 37 133',
    '--gold-dark': '210 20 110',
    '--gold-darker': '170 8 88',
    '--mountain-light': '114 9 183',
    '--mountain': '86 11 173',
    '--mountain-dark': '58 12 163',
    '--mountain-darker': '30 6 100',
    '--sand-lightest': '255 255 255',
    '--sand-light': '250 251 250',
    '--sand': '240 238 248',
    '--sand-dark': '220 215 240'
  },
  dark: {
    '--gold-light': '253 197 0',
    '--gold': '247 37 133',
    '--gold-dark': '210 20 110',
    '--gold-darker': '170 8 88',
    '--mountain-light': '114 9 183',
    '--mountain': '86 11 173',
    '--mountain-dark': '58 12 163',
    '--mountain-darker': '30 6 100',
    '--sand-lightest': '12 6 22',
    '--sand-light': '20 8 36',
    '--sand': '30 12 52',
    '--sand-dark': '44 16 70'
  }
}];
function applyPaletteAndMode(palette: Palette, mode: PaletteMode) {
  const root = document.documentElement;
  const vars = mode === 'dark' ? palette.dark : palette.light;
  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
  root.setAttribute('data-mode', mode);
}
export function App() {
  const [view, setView] = useState<'landing' | 'palettes'>('landing');
  const [activePaletteId, setActivePaletteId] = useState('nordic');
  const [mode, setMode] = useState<PaletteMode>('light');
  const activePalette = PALETTES.find(p => p.id === activePaletteId)!;
  const handleSelectPalette = (palette: Palette) => {
    setActivePaletteId(palette.id);
    applyPaletteAndMode(palette, mode);
    setView('landing');
  };
  const handleToggleMode = () => {
    const newMode: PaletteMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    applyPaletteAndMode(activePalette, newMode);
  };
  return <>
      {view === 'landing' ? <LandingPage data-id="element-0" /> : <ColorPalettePage data-id="element-1" />}

      {/* Floating palette switcher */}
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 rounded-2xl shadow-2xl" style={{
      backgroundColor: 'rgba(12,12,12,0.94)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255,255,255,0.1)'
    }} data-id="element-2">
        {/* Nav tabs */}
        <button onClick={() => setView('landing')} className="text-xs font-medium px-3 py-1.5 rounded-lg" style={{
        backgroundColor: view === 'landing' ? 'rgba(255,255,255,0.15)' : 'transparent',
        color: view === 'landing' ? '#fff' : 'rgba(255,255,255,0.4)'
      }} data-id="element-3">
          Svetainė
        </button>
        <button onClick={() => setView('palettes')} className="text-xs font-medium px-3 py-1.5 rounded-lg" style={{
        backgroundColor: view === 'palettes' ? 'rgba(255,255,255,0.15)' : 'transparent',
        color: view === 'palettes' ? '#fff' : 'rgba(255,255,255,0.4)'
      }} data-id="element-4">
          Paletės
        </button>

        {/* Divider */}
        <div style={{
        width: 1,
        height: 22,
        backgroundColor: 'rgba(255,255,255,0.12)'
      }} data-id="element-5" />

        {/* Light / Dark toggle */}
        <button onClick={handleToggleMode} title={mode === 'light' ? 'Perjungti į tamsų režimą' : 'Perjungti į šviesų režimą'} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium" style={{
        backgroundColor: 'rgba(255,255,255,0.08)',
        color: 'rgba(255,255,255,0.75)',
        border: '1px solid rgba(255,255,255,0.12)'
      }} data-id="element-6">
          <span style={{
          fontSize: 14,
          lineHeight: 1
        }} data-id="element-7">
            {mode === 'light' ? '☀️' : '🌙'}
          </span>
          <span data-id="element-8">{mode === 'light' ? 'Light' : 'Dark'}</span>
        </button>

        {/* Divider */}
        <div style={{
        width: 1,
        height: 22,
        backgroundColor: 'rgba(255,255,255,0.12)'
      }} data-id="element-9" />

        {/* Palette swatches */}
        {PALETTES.map(palette => <button key={palette.id} onClick={() => handleSelectPalette(palette)} title={palette.name} className="relative flex rounded-lg overflow-hidden" style={{
        width: 36,
        height: 22,
        outline: activePaletteId === palette.id ? '2px solid rgba(255,255,255,0.9)' : '2px solid transparent',
        outlineOffset: 2,
        transform: activePaletteId === palette.id ? 'scale(1.18)' : 'scale(1)',
        transition: 'transform 0.15s ease, outline-color 0.15s ease'
      }} data-id="element-10">
            {palette.colors.slice(0, 3).map((color, i) => <div key={i} style={{
          flex: 1,
          backgroundColor: color
        }} data-id="element-11" />)}
          </button>)}
      </div>
    </>;
}